export const IMG_URL = 'https://hqo.imgix.net/';

/**
 * CDN the Helix image uploads are served from. Helix returns a relative path (`uploads/…`) from
 * `/images/upload`, and absolute resource image urls it hands out are already on this host — so
 * this is a fixed piece of infrastructure, the same in every environment, not a per-env setting.
 */
export const RESOURCE_IMAGE_CDN_URL = 'https://dmevq6vd3sz66.cloudfront.net';
